import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Modal from '../../../components/Modal';
import Button from '../../../components/Button';
import Icon from '../../../components/Icon';
import messages from './messages';

import './styles.css';

const ErrorModal = ({
  openModal,
  onClose,
  onSubmit,
}) => (
  <Modal
    open={openModal}
    onClose={onClose}
  >
    <div styleName="error-modal-header">
      <Icon name="times circle" size="large" styleName="header-title-icon" aria-label="times circle" />
      <FormattedMessage styleName="header-title" {...messages.header} />
    </div>
    <div styleName="error-modal-content">
      <h3><FormattedMessage {...messages.content} /></h3>
      <p><FormattedMessage {...messages.retry} /></p>
    </div>
    <div styleName="error-modal-div">
      <div styleName="error-modal-actions">
        <Button onClick={onClose} id="cancelBtn">
          <FormattedMessage {...messages.cancelButton} />
        </Button>
        <Button primary onClick={onSubmit} id="submitBtn">
          <FormattedMessage {...messages.submitButton} />
        </Button>
      </div>
    </div>
  </Modal>
);

ErrorModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  openModal: PropTypes.bool,
};

export default ErrorModal;
